import Grid from '@mui/material/Grid2';
import Typography from '@mui/material/Typography';
import {Box, Card, Stack, useTheme } from '@mui/material';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';

const StaffList = [
{
    department: "Administration",
    members: [
        { name: "William C. Campbell", title: "Director", dept: "Administration", phone: "617-979-8300", email: "William.Campbell", assignment: "" },
        { name: "Brittany Manning", title: "Chief Financial Officer", dept: "Administration", phone: "617-979-8308", email: "Brittany.Manning", assignment: "" },
        { name: "Robert Caldarelli", title: "Administrative Assistant", dept: "Administration", phone: "617-979-8306", email: "Robert.Caldarelli", assignment: "" },
    ]
},
{
    department: "Legal",
    members: [
        { name: "Sarah Hartry", title: "General Counsel", dept: "Legal", phone: "617-979-8307", email: "Sarah.Hartry", assignment: "" },
        { name: "Evert Fowle", title: "Deputy General Counsel", dept: "Legal", phone: "617-979-8321", email: "Evert.Fowle", assignment: "" },
        { name: "Daniel Barros", title: "Legal Counsel", dept: "Legal", phone: "617-979-8304", email: "Daniel.Barros", assignment: "" },
        { name: "Hannah Campbell", title: "Legal Counsel", dept: "Legal", phone: "617-979-8320", email: "Hannah.Campbell", assignment: "" },
        { name: "Michael Joyce", title: "Financial Investigator & Public Finance Administrator	", dept: "Legal / Audit", phone: "617-979-8314", email: "Michael.Joyce", assignment: "All IEPACs<br>Ballot Question Committees<br>Segregated Fund Accounts" },
    ]
},
{
    department: "Audit",
    members: [
        { name: "Daniel Juffre", title: "Audit Director", dept: "Audit", phone: "617-979-8312", email: "Daniel.Juffre", assignment: "Candidates: O-Q (first letter of candidate's last name)<br/>Democratic & Republican State Committees" },
        { name: "Sheila Cole", title: "Auditor", dept: "Audit", phone: "617-979-8301", email: "Sheila.Cole", assignment: "Local Party Committees" },
        { name: "Caroline Paras", title: "Auditor", dept: "Administration / Audit", phone: "617-979-8305", email: "Caroline.Paras", assignment: "Candidates: A-C (first letter of candidate's last name)<br/>PACs: 80601-89999" },
        { name: "Chloe Rosette", title: "Auditor", dept: "Audit", phone: "617-979-8313", email: "Chloe.Rosette", assignment: "Candidates: K - N (first letter of candidate's last name)<br>PACs: 80301-80600" },
        { name: "Sarabeth McClain", title: "Auditor", dept: "Audit", phone: "617-979-8325", email: "Sarabeth.McClain", assignment: "Candidates: D-J (first letter of candidate's last name)<br>Bank Liaison" },
        { name: "Ryan Wilburn", title: "Auditor", dept: "Audit", phone: "617-979-8324", email: "Ryan.Wilburn", assignment: "Candidates: R-Z (first letter of candidate's last name)<br>PACs: 80000-80300" },
    ]
},
{
    department: "Communications & Technology",
    members: [
        { name: "Albert Grimes", title: "Chief Information Officer", dept: "Communications & Technology", phone: "617-979-8319", email: "Albert.Grimes", assignment: "" },
        { name: "Jason Tait", title: "Director of Communications & Public Education", dept: "Communications & Technology", phone: "617-979-8309", email: "Jason.Tait", assignment: "" },
        { name: "Xiaoyi An", title: "Senior Application Developer", dept: "Communications & Technology", phone: "617-979-8311", email: "Xiaoyi.An", assignment: "" },
        { name: "Andrew Cohen", title: "IT Support Engineer", dept: "Communications & Technology", phone: "617-979-8310", email: "Andrew.Cohen2", assignment: "" },
    ]
}

]

const StaffDirectory = (): JSX.Element => {

    const theme = useTheme();

    return (
    <Box marginTop={3} marginBottom={4}>
        <Box marginBottom={4}>
            <Typography
                variant="h6"
                fontWeight={550}
                gutterBottom
                align={'center'}
            >
            Staff Directory
            </Typography>
        </Box>
        <Grid container spacing={4}>
            {
                StaffList.map((item, i) => (
                    <Grid key={i} container spacing={2} marginBottom={4}>
                        <Grid size={12}>
                            <Typography
                                variant="subtitle1"
                                color={'text.primary'}
                                fontWeight={550}
                                gutterBottom
                                align={'left'}
                                sx={{
                                    textTransform: 'uppercase',
                                }}
                            >
                            {item.department}
                            </Typography>
                        </Grid>
                        {
                            item.members.map((member, i) => (
                                <Grid size={{xs:7, md:4}} key={i}>
                                    <Card
                                        sx={{
                                            p: 2,
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            width: 1,
                                            height: 1,
                                            backgroundColor: 'alternate.main',
                                            '&:hover': {
                                                transform: `translateY(-${theme.spacing(1 / 2)})`,
                                            },
                                        }}
                                    >
                                        <Typography marginTop={1} fontWeight={550} color="primary">
                                            {member.name}
                                        </Typography>
                                        <Typography textAlign={"center"} color={'text.secondary'}>{member.title}</Typography>
                                        <Stack
                                             marginTop={3}
                                             width={1}
                                             alignItems={'center'}
                                             spacing={1}
                                        >
                                            <Typography variant={'subtitle2'}>
                                                {member.phone}
                                            </Typography>
                                            <Stack direction="row">
                                                <Typography variant={'subtitle2'}>
                                                    {member.email}
                                                </Typography>
                                                <AlternateEmailIcon sx={{ fontSize: 18, padding:0.2}} />
                                                <Typography variant={'subtitle2'}>
                                                    mass.gov
                                                </Typography>
                                            </Stack>
                                            
                                            {
                                                member.assignment &&
                                                <>
                                                <Typography component={'p'} variant={'body2'} textAlign={"center"}>
                                                        <Typography component={"i"} variant={'subtitle2'} marginBottom={0.3}>
                                                            <u>Audit Assignment:</u>
                                                        </Typography>
                                                        <div dangerouslySetInnerHTML={{ __html: member.assignment }}></div>
                                                </Typography> 
                                                </>
                                            }
                                        </Stack>
                                    </Card>
                                </Grid>
                            ))
                        }
                    </Grid>
                ))
            }
        </Grid>
    </Box>
  );
};

export default StaffDirectory;